import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { isEmpty } from "lodash";
import { useTableContext } from "../BaseTableContext";
import { Modal, Switch } from "antd";
import { Button } from "../../Button/Button";
import { useSupportedSwitchOrPaginationSize } from "../../InputComponent/Input";
const ColumnsEditModal = ({ tableId, columns, size }) => {
    const [visible, setVisible] = useState(false);
    const [selectedColumnIds, setSelectedColumnIds] = useState([]);
    const { getShownColumns, settings, onSettingsChange } = useTableContext();
    const shownColumns = useMemo(() => getShownColumns(tableId), [tableId, settings]);
    const onUpdateColumns = () => {
        setVisible(false);
        onSettingsChange(tableId, {
            shownColumns: selectedColumnIds
        });
    };
    const onSelect = (checked, val) => {
        if (checked) {
            setSelectedColumnIds([...selectedColumnIds, val]);
        }
        else {
            setSelectedColumnIds(selectedColumnIds.filter((id) => id !== val));
        }
    };
    useEffect(() => {
        if (visible) {
            setSelectedColumnIds(isEmpty(shownColumns)
                ? columns.map(({ value }) => value)
                : shownColumns);
        }
    }, [visible]);
    const _columns = useMemo(() => {
        return columns.reduce((result, c) => {
            var _a, _b, _c;
            // Check the case label is an object
            if (typeof c.label === "object" && c.label && c.label.props) {
                return [
                    ...result,
                    Object.assign(Object.assign({}, c), { label: Object.assign(Object.assign({}, c.label), { props: Object.assign(Object.assign({}, c.label.props), { children: ((_c = (_b = (_a = c === null || c === void 0 ? void 0 : c.label) === null || _a === void 0 ? void 0 : _a.props) === null || _b === void 0 ? void 0 : _b.children) === null || _c === void 0 ? void 0 : _c.filter((child) => { var _a; return ((_a = child === null || child === void 0 ? void 0 : child.type) === null || _a === void 0 ? void 0 : _a.name) !== "Filter"; })) || [] }) }) })
                ];
            }
            // Check the case label is a string
            if (typeof c.label === "string" && c)
                return [...result, c];
            return result;
        }, []);
    }, [columns]);
    const switchSize = useSupportedSwitchOrPaginationSize(size);
    return (_jsxs(_Fragment, { children: [_jsx(Button, { size: size, onClick: () => setVisible(true), children: "Hide columns" }), _jsx(Modal, { title: "Edit visible columns", visible: visible, onCancel: () => setVisible(false), onOk: onUpdateColumns, okButtonProps: {
                    disabled: isEmpty(selectedColumnIds)
                }, children: _jsx("div", { className: "te-grid te-gap-x-10 te-gap-y-6 te-flex-wrap te-justify-between te-grid-cols-2", children: _columns.map((col) => (_jsxs("div", { className: "te-flex te-items-center te-gap-x-2", children: [_jsx(Switch, { size: switchSize, checked: selectedColumnIds.includes(col.value), onChange: (checked) => onSelect(checked, col.value) }), _jsx("span", { className: "truncate te-whitespace-nowrap", children: col.label })] }, col.value))) }) })] }));
};
export default ColumnsEditModal;
